<template>
  <div class="h-full w-full flex flex-col items-center justify-center mt-10">
    <contact-us-form
      :show="showContactSales"
      @close="closeContactSales"
      :formId="contactSalesFormId"
    />
    <h1 class="text-[50px] dark:text-primary-white font-semibold">
      {{ $t("pricing.title") }}
    </h1>
    <span
      class="text-sm font-medium text-secondary-400 dark:text-secondary-200"
    >
      {{ $t("pricing.description") }}
    </span>
    <div class="pricing-interval">
      <span :class="{ 'selected-interval': !isAnnual }">
        {{ $t("pricing.period.monthly") }}
      </span>
      <div
        class="flex items-center cursor-pointer"
        @click="isAnnual = !isAnnual"
      >
        <div class="relative">
          <input
            type="checkbox"
            id="toggle121"
            class="sr-only"
            v-model="isAnnual"
          />
          <div
            class="toggle__line"
            :class="{
              'bg-checkbox-blue': isAnnual,
              'bg-greyscale-200': !isAnnual,
            }"
          >
            <div
              class="toggle__dot"
              :class="{
                'right-0.5': isAnnual,
                'left-0.5': !isAnnual,
              }"
            ></div>
          </div>
        </div>
      </div>
      <span :class="{ 'selected-interval': isAnnual }">
        {{ $t("pricing.period.annually") }}
      </span>
      <div class="interval-discount">{{ $t("pricing.discount") }}</div>
    </div>
    <div class="flex flex-row items-center justify-center">
      <pricing-card
        v-for="(card, index) in cards"
        :key="index"
        :plan="card"
        :isAnnual="isAnnual"
        @upgrade="upgrade(card)"
      />
    </div>
  </div>
</template>

<script>
import PricingCard from "@/components/PricingCard";
import { FORM_ID_LIST, PRICING } from "@/constants";
const ContactUsForm = () => import("@/components/ContactUsForm");
export default {
  name: "Pricing",
  components: { PricingCard, ContactUsForm },
  data() {
    return {
      showContactSales: false,
      contactSalesFormId: "",
      formIdList: FORM_ID_LIST,
      cards: PRICING,
      isAnnual: true,
    };
  },
  methods: {
    closeContactSales() {
      this.showContactSales = false;
    },
    upgrade(card) {
      if (card.type === "Enterprise") {
        this.contactSalesFormId = this.formIdList.ENTERPRISE;
      } else if (card.type === "Unlimited") {
        this.contactSalesFormId = this.isAnnual
          ? this.formIdList.UNLIMITED_ANNUAL
          : this.formIdList.UNLIMITED_MONTH;
      } else {
        this.contactSalesFormId = this.isAnnual
          ? this.formIdList.BUSINESS_ANNUAL
          : this.formIdList.BUSINESS_MONTH;
      }
      this.showContactSales = true;
    },
  },
};
</script>

<style>
@import "index.module.css";
</style>
